import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

const UserInfo = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  const handleChangePassword = (e) => {
    e.preventDefault();
    navigate("/changePassword");
  };

  return (
    <div className="login-info">
      <span>
        <Dropdown>
          <Dropdown.Toggle as="a" className="dropdown-toggle">
            <img src={"/assets/img/avatars/sunny.png"} alt="me" className="online" />
            <span>{userInfo?.name}</span>
            <i className="fa fa-angle-down" />
          </Dropdown.Toggle>
          <Dropdown.Menu as="ul" className="dropdown-menu">
            <Dropdown.Item as="li">
              <a href="/" onClick={handleChangePassword} className="dropdown-item">
                <i className="fa fa-key" style={{ marginRight: 8 }} />
                Đổi mật khẩu
              </a>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </span>
    </div>
  );
};

export default UserInfo;
